export default "__VITE_ASSET__DJH9Z6bL__"